import {
    DefinitionProduct,
    SharedDefinitions
} from "@mrdm-self-service-frontend/shared/data-access-definitions";

export function getBaseProductCode(definitions: SharedDefinitions, productCode: string): string {
    return definitions.product[productCode]?.parentCode || productCode;
}

export function getBaseProduct(
    definitions: SharedDefinitions,
    productCode: string
): DefinitionProduct {
    const baseProductCode = getBaseProductCode(definitions, productCode);
    return definitions.product[baseProductCode];
}
